  document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function() {
      var link = document.getElementById("more-payment-options-link");
      if (link) {
        link.textContent = "Go to checkout";
      }
    }, 1500); 
  });

// Checkout Buttons

document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const dynamicBtn = document.querySelector('.shopify-payment-button__more-options');
    if (dynamicBtn) {
      dynamicBtn.textContent = 'Go to Checkout';
      
    }
  }, 1000); // Check every second
});
